export default __webpack_public_path__ + "static/media/REPAIR_EMULSION_Y.11fcddd6.png";